import { T as o } from "./index-1e1dfdf2.js";
import "react";
import "react-dom";
import "./index-efd35e77.js";
import "./index-c07310bf.js";
import "./index-64063129.js";
import "./auto-scroll-b2de6e53.js";
import "./Popup-b6c9078b.js";
class d extends o {
  render() {
    return super.render();
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-useless-constructor
  constructor(r) {
    super(r);
  }
}
export {
  d as Tooltip
};
